import { useQuery } from 'react-query'
import AIGenerationService from 'src/services/ai-generation.service'

import { QUERY_KEYS } from 'src/constants'
import { getUserIdAndRolesFromToken } from 'src/common/utils'

const useGetWebChatbotHistory = () => {
  const userData = getUserIdAndRolesFromToken()

  const userId = userData?.id

  return useQuery(
    [QUERY_KEYS.WEB_CHATBOT_HISTORY, userId],
    () => AIGenerationService.getUserChatBotHistory(),
    {
      keepPreviousData: true,
    },
  )
}

export { useGetWebChatbotHistory }
